import React, { memo, useContext } from "react";
import { useHistory } from "react-router";
import AppContext from "../contexts/AppContext";
import { setRedmine } from "../actions";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import { makeStyles } from "@material-ui/core/styles";
import CustomAvatar from "./atoms/custom_avatar";
import componentStyles from "../assets/styles/components/issue_list";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles(componentStyles);

const IssueList = memo((props) => {
  const { state, dispatch } = useContext(AppContext);
  const issues = props.issues || [];
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const handleClickListItem = async (issue) => {
    const { redmine_id } = issue;
    if (redmine_id) {
      const config = state.siteConfigs.find(
        (config) => config.id === redmine_id
      );
      await setRedmine(dispatch, config);
    }
    history.push({
      pathname: "/issue/" + issue.id,
    });
  };

  return (
    <>
      <List>
        {issues.map((issue, index) => {
          let auther = issue.author;
          let assignee = issue.assigned_to;
          return (
            <ListItem
              className={classes.listItem}
              alignItems="flex-start"
              key={index}
              button
              onClick={(e) => handleClickListItem(issue)}
            >
              <ListItemAvatar align="center" style={{ marginRight: 10 }}>
                {assignee ? (
                  <Badge
                    overlap="circle"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    badgeContent={
                      <CustomAvatar
                        className={classes.smallAvatar}
                        userId={assignee.id}
                        redmineurl={
                          issue.redmineurl || state.current?.redmineurl
                        }
                      >
                        {assignee.name?.slice(0, 2)}
                      </CustomAvatar>
                    }
                  >
                    <CustomAvatar
                      className={classes.green}
                      userId={auther.id}
                      redmineurl={issue.redmineurl || state.current?.redmineurl}
                    >
                      {auther.name?.slice(0, 2)}
                    </CustomAvatar>
                  </Badge>
                ) : (
                  <CustomAvatar
                    className={classes.green}
                    userId={auther.id}
                    redmineurl={issue.redmineurl || state.current?.redmineurl}
                  >
                    {auther.name?.slice(0, 2)}
                  </CustomAvatar>
                )}
              </ListItemAvatar>
              <Grid item xs>
                <ListItemText
                  primary={
                    <>
                      <Typography className={classes.issueTitle}>
                        {issue.subject}
                        {issue.redmine_name ? (
                          <span className={classes.issueRedmineName}>
                            {issue.redmine_name}
                          </span>
                        ) : (
                          ""
                        )}
                      </Typography>
                    </>
                  }
                />
                <Box className={classes.issueParams}>
                  <Box className={classes.issueParam}>
                    {t("field_status")}:{" "}
                    <Box className={classes.issueParamValue}>
                      {issue.status.name}
                    </Box>
                  </Box>
                  <Box className={classes.issueParam}>
                    {t("field_due_date")}:{" "}
                    <Box className={classes.issueParamValue}>
                      {issue.due_date}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </ListItem>
          );
        })}
      </List>
    </>
  );
});

export default IssueList;
